import React from 'react';
import { Button } from '../../components/Bootstrap';
import { NobleModal } from '../../components';
import { OrdersListQuery_orders_orders as Order } from './__generated__/OrdersListQuery';

interface RefundModalProps {
  open: boolean;
  order?: Order;
  toggle: () => void;
  onRefund: () => void;
}

interface RefundModalState {
  name: string;
}

export class RefundModal extends React.Component<RefundModalProps, RefundModalState> {
  render() {
    return (
      <NobleModal size='lg' isOpen={this.props.open} toggle={this.props.toggle}>
        <NobleModal.Title title='Are you sure?' />
        <NobleModal.Body>
          <p className='menu-modal-desc text-center'>
            Are you sure you’d like to refund ${this.props.order?.total} of order #{this.props.order?.orderId}? This
            cannot be undone.
          </p>
          <div className='text-center menu-modal-btns'>
            <Button type='button' color='link' className='me-4' onClick={this.props.toggle}>
              Cancel
            </Button>{' '}
            <Button type='submit' color='primary' onClick={this.props.onRefund}>
              Refund
            </Button>
          </div>
        </NobleModal.Body>
      </NobleModal>
    );
  }
}
